import { render, staticRenderFns } from "./NotificationsFilters.vue?vue&type=template&id=31df67de&"
import script from "./NotificationsFilters.vue?vue&type=script&lang=ts&"
export * from "./NotificationsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsFilters.vue?vue&type=style&index=0&id=31df67de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports